import { init } from '@cfdigven/cfwp-promotions-banner-widget';

// Configuration
const CONFIG = {
  elementPlacement: 'multi-cta-promo-banner',
  elementName: 'multi cta promostional banner',
  eventName: 'with-multi-cta-promo',
  pageTypeField: 'pagetype',
  defaultPageType: 'pagetype-generic',
};

// State
const state = {
  isReady: false,
  isLoaded: false,
  descriptionEventsSet: false,
};

// Get page type
const pageTypeValue = document.getElementById(CONFIG.pageTypeField)?.value || CONFIG.defaultPageType;

// Event handling
const triggerWithMultiCTAPromoEvent = (hasData = false) => {
  window.dispatchEvent(new CustomEvent(CONFIG.eventName, { detail: { hasData } }));
};

const loadData = async () => {
  try {
    const { postId, promotionalBannerApiUrl } = window?.site_settings || {};
    const response = await fetch(`${promotionalBannerApiUrl}${postId}`);

    if (!response?.ok) {
      triggerWithMultiCTAPromoEvent(false);
      return null;
    }

    const data = await response.json();
    const hasPromotions = data?.promotions?.length > 0;

    document.body.classList.toggle('with-multi-cta-promo', hasPromotions);
    triggerWithMultiCTAPromoEvent(hasPromotions);

    return data;
  } catch (error) {
    triggerWithMultiCTAPromoEvent(false);
    return null;
  }
};

const trackEvent = (eventData) => {
  console.log('Event Data:', eventData);
  window.dataLayer.push(eventData);
};

const onReady = () => {
  const eventData = {
    event: 'sponsored_impression',
    elementPlacement: CONFIG.elementPlacement,
    elementName: CONFIG.elementName,
    serviceProvider: null,
    pageType: pageTypeValue,
  };

  trackEvent(eventData);
  state.isReady = true;
};

const onPromoClick = (promotion = false) => {
  if (!state.isReady || !state.isLoaded) return;

  trackEvent({
    event: 'sponsored_click_out',
    elementPlacement: CONFIG.elementPlacement,
    elementClicked: 'promotion',
    elementName: CONFIG.elementName,
    serviceProvider: promotion?.title,
    pageType: pageTypeValue,
    destinationType: promotion?.isExternalCtaUrl ? 'external' : 'internal',
    href: window?.location?.href,
  });
};

const onOpen = (isOpen) => {
  if (!state.isReady) return;

  if (!state.isLoaded) {
    state.isLoaded = true;
    return;
  }

  if (!state.descriptionEventsSet) {
    trackDescriptionClicks();
    state.descriptionEventsSet = true;
  }

  trackEvent({
    event: 'on_page_link_click',
    elementPlacement: CONFIG.elementPlacement,
    elementClicked: 'open/close',
    pageType: pageTypeValue,
    pageUrl: window?.location?.href,
    direction: isOpen ? 'open' : 'close',
  });

  document.body.classList.toggle('multi-cta-promo-open', isOpen);
};

const trackDescriptionClicks = () => {
  const promoBannerElement = document.querySelector('#offers-promo-widget-app');
  if (!promoBannerElement) return;

  promoBannerElement.addEventListener('click', (event) => {
    const path = event.composedPath?.() || [];
    const [actualTarget, actualTargetParent] = path;

    if (!actualTarget?.tagName === 'A' ||
        !actualTargetParent?.classList?.contains('offers-promo-widget__card-description')) {
      return;
    }

    const href = actualTarget.getAttribute('href');
    if (!href) return;

    const linkText = actualTarget.textContent?.trim();
    const siblings = Array.from(actualTargetParent.querySelectorAll('a'));
    const position = siblings.indexOf(actualTarget) + 1;
    if (position <= 0) return;

    const isExternal = new URL(href, location.origin).origin !== location.origin;
    const eventAction = isExternal ? 'external_link_click' : 'internal_link_click';

    trackEvent({
      event: eventAction,
      elementPlacement: CONFIG.elementPlacement,
      elementClicked: 'description-link',
      pageType: pageTypeValue,
      position,
      href,
      linkText,
    });
  });
};

export const loadBanners = () => {
  init(loadData, onReady, onOpen, onPromoClick);
};
